export default "__VITE_ASSET__a3cc8a08__"